import { render, staticRenderFns } from "./Page5Brand.vue?vue&type=template&id=46826fae&scoped=true"
import script from "./Page5Brand.vue?vue&type=script&lang=js"
export * from "./Page5Brand.vue?vue&type=script&lang=js"
import style0 from "./Page5Brand.vue?vue&type=style&index=0&id=46826fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46826fae",
  null
  
)

export default component.exports